/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
export class PagingControls {
    // Start Index with 0 as the starting one
    start = 0;
    // Page Size
    size = 50;
    // Sort Order
    order = "ASC";
    // Filter String
    filterString: string;

    /**
     * Creates the GET URL Parameters that should
     * be used to specify the paging parameters.
     * 
     * Expects the starting query parameter specifier ['?', '&'] to 
     * be specified externally.
     */
    public toUrlParamString(): string {
        let rv = "";
        let paramAdded = false;

        const start = this.start;
        if (start != null) {
            rv = rv + `start=${start}`;
            paramAdded = true;
        }
        const size = this.size;
        if (size != null) {
            if (paramAdded) {
                rv = rv + `&`;
            }
            rv = rv + `size=${size}`;
            paramAdded = true;
        }
        const order = this.order;
        if (order != null) {
            if (paramAdded) {
                rv = rv + `&`;
            }
            rv = rv + `order=${order}`;
            paramAdded = true;
        }
        const filterString = this.filterString;
        if (filterString != null) {
            if (paramAdded) {
                rv = rv + `&`;
            }
            rv = rv + `filterString=${filterString}`;
            paramAdded = true;
        }
        return rv;
    }
}
